module.exports = __webpack_public_path__ + "img/team-02.886c5b36.jpg";